module.exports = __webpack_public_path__ + "static/media/affyn.7f45d5ef.jpg";